import { useSelector } from "react-redux";
import { RootState } from "../../state";
import { roles } from "../../types/authTypes";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import DialogService from "../Dialog/dialogService";

interface LinkWrapperProps {
  visitorUrl: string;
  freeUserUrl: string;
  premiumUserUrl: string;
  component: any;
  style?: any;
  clickFunction?: Function;
  closeOnVisitor?: boolean;
  closeOnSigned?: boolean;
}

const LinkWrapper = ({
  visitorUrl,
  freeUserUrl,
  premiumUserUrl,
  component,
  style: styleProps,
  clickFunction,
  closeOnVisitor,
  closeOnSigned,
}: LinkWrapperProps) => {
  const [targetUrl, setTargetUrl] = useState<string | undefined>(undefined);
  const [launchClick, setLaunchClick] = useState<boolean>(false);
  const [closeAfterClick, setCloseAfterClick] = useState<boolean>(false);

  const { close } = DialogService();

  const loginData = useSelector((state: RootState) => state.login);

  useEffect(() => {
    if (loginData.role === roles.VISITOR) {
      setTargetUrl(visitorUrl);
      if (closeOnVisitor === true) {
        setCloseAfterClick(true);
      }
    } else {
      if (loginData.role === roles.FREE) {
        setTargetUrl(freeUserUrl);
        setLaunchClick(true);
        if (closeOnSigned === true) {
          setCloseAfterClick(true);
        }
      } else {
        if (loginData.role === roles.PREMIUM) {
          setTargetUrl(premiumUserUrl);
          setLaunchClick(true);
          if (closeOnSigned === true) {
            setCloseAfterClick(true);
          }
        }
      }
    }
  }, [visitorUrl, freeUserUrl, premiumUserUrl]);

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (clickFunction && launchClick === true) {
      clickFunction();
    }
    if (closeAfterClick === true) {
      close();
    }
    event.stopPropagation();
  };

  return targetUrl !== undefined ? (
    styleProps !== undefined ? (
      <Link to={targetUrl} onClick={handleClick} style={styleProps}>
        {component}
      </Link>
    ) : (
      <Link to={targetUrl} onClick={handleClick}>
        {component}
      </Link>
    )
  ) : (
    <></>
  );
};

export default LinkWrapper;
